import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import EditMatchPageNew from "../../components/MatchDiscoveryControl/EditMatchPageNew";

const MatchList = () => {
  return (
    <>
      <MasterLayout>
        <Breadcrumb id="title" title2="Match Users" link2="/match-control" title="Edit Match" />
        <EditMatchPageNew />
      </MasterLayout>
    </>
  );
};

export default MatchList;
